import styled, {css} from 'styled-components';
import {DisplayIcon as BaseDisplayIcon} from 'components/acommon/FieldSelect';
import {Label} from 'components/acommon/FieldInput/styled';
import {Wrapper as InputWrapper} from 'components/acommon/FieldInput/styled';
import {StyledButton as ButtonLabel} from 'components/Button/styled';
import {device} from 'styled/device';

type MenuProps = {
  open?: boolean;
};

type OptionProps = {
  selected?: boolean;
};

type SelectedCountryCodeContainerProps = {
  disabled?: boolean;
  error?: string;
  isEmpty?: boolean;
};

export const SelectedCountryCodeContainer = styled.button<SelectedCountryCodeContainerProps>`
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: absolute;
  left: 0;
  bottom: 0;
  height: 50px;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 5px 7px 5px 16px;
  width: 87px;
  cursor: pointer;
  z-index: 1;
  text-align: left;
  font-family: Poppins-Regular, sans-serif;
  font-size: 16px;
  color: #353945;
  user-select: none;
  outline: none;
  margin-top: 25px;
  background: transparent;
  border: none;

  ${props =>
    props.error &&
    css`
      border-color: #ff2467;
    `}

  ${props =>
    props.isEmpty &&
    css`
      color: #777e90;
    `};

  ${props =>
    props.disabled &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
    `};

  @media (max-width: ${device.tablet}) {
    font-size: 16px;
  }
`;

type WrapperProps = {
  error?: string;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  width: 100%;
  text-align: center;
  background-color: white;

  & ${InputWrapper} {
    width: auto;
    min-height: unset;
  }

  & .input__input {
    height: 50px;
    color: #161643;
    padding: 0 10px 0 90px;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    ${props =>
      props.error &&
      css`
        border-color: #f84b7a;
      `}
  }

  & ${Label} {
    min-height: unset;
    position: absolute;
    max-width: 250px;
    overflow-x: hidden;
    white-space: nowrap;
    top: 0;
  }
`;

export const CountryCodesContainer = styled.div`
  overflow-y: auto;
  height: 191px;
  text-align: left;
`;

export const DisplayIcon = styled(BaseDisplayIcon)`
  padding-left: 9px;
  width: 24px;
  box-shadow: none;
  margin-right: 0;
`;

export const Menu = styled.div<MenuProps>`
  width: 100%;
  height: 265px;
  box-shadow: 0 15px 15px 0 rgba(38, 153, 251, 0.1);
  position: absolute;
  left: 0;
  z-index: 3;
  background-color: white;
  top: 80px;
  padding: 15px 0 0 16px;
  box-sizing: border-box;
  text-align: left;
  visibility: hidden;
  margin-bottom: 30px;
  border-radius: 3px;

  ${props =>
    props.open &&
    css`
      visibility: visible;
    `};

  @media (max-width: ${device.mobileL}) {
    width: 280px;
  }
`;

export const SearchIcon = styled.img`
  height: 16px;
  width: 16px;
  position: absolute;
  top: 8px;
  left: 8px;
`;

export const SearchInput = styled.input`
  outline: none;
  border: none;
  width: 140px;
  height: 30px;
  position: absolute;
  top: 0;
  left: 32px;

  &,
  &::placeholder {
    font-family: inherit;
    font-size: 18px;
    line-height: 1.18;
    text-align: left;
    color: #2194f7;
  }
`;

export const InputRelativeWrapper = styled.div`
  width: 140px;
  height: 30px;
  position: relative;
  padding-bottom: 18px;
  margin: 0 !important;
`;

export const Divider = styled.div`
  background-color: rgba(231, 235, 241, 0.51);
  height: 1px;
  margin: 5px 37px 5px 0;
`;

export const Option = styled.div<OptionProps>`
  font-family: inherit;
  font-size: 16px;
  text-align: left;
  line-height: 1.18;
  color: #161643;
  cursor: pointer;
  padding: 16px 0 16px 20px !important;

  &:hover {
    cursor: pointer;
    background-color: #f4f5f6;
    font-family: inherit;
    color: #23262f;
    font-weight: 400;
    border-radius: 12px;
  }

  ${props =>
    props.selected &&
    css`
      font-family: inherit;
      cursor: default;

      &:hover {
        color: #2d508e;
      }
    `};
`;

export const OptionWrapper = styled.div`
  margin-right: 37px;
`;

export const LoaderWrapper = styled.div`
  width: 16px;
  position: absolute;
  top: 8px;
  right: 2px;
  z-index: 3;
`;

export const RequestErrorMessage = styled.div`
  position: absolute;
  top: 23px;
  right: 0;
  font-family: ProximaNova-Bold, sans-serif;
  font-size: 13px;
  z-index: 3;
  color: #ff2467;

  & > button {
    height: 20px;
    min-width: auto;
    font-size: 10px;
    background-color: #ff2467;
    border-color: #ff2467;

    & > ${ButtonLabel} {
      height: auto;
    }
  }
`;

export const EmptyOption = styled.div`
  font-family: inherit;
  text-align: left;
  font-weight: 500;
  line-height: 1.18;
  padding: 19px 9px 18px;
  color: #2d508e;
  opacity: 0.5;
  font-size: 18px;
`;
